<template>
	<div class="abody">
		<el-card class="box-card" v-loading="!nums.status0">
			<div>
				<div>
					<div style="font-size: 105%;margin-bottom: 10px;">今日数据</div>
				</div>
				<div class="aflex" v-if="nums.status0">
					<div>
						<div class="agrey atitle">待处理事项</div>
						<div class="aaflex" style="margin-top: 5px;align-items: flex-end;">
							<div class="agrey">日</div>
							<shuzi style="font-size: 140%;" class="shuziren" :num="nums.status0[0]" :warn="false"
								:color="true"></shuzi>
						</div>
						<div class="aaflex">
							<div class="agrey">周</div>
							<shuzi class="shuziren" :num="nums.status0[1]" :warn="true" :color="true"></shuzi>
						</div>
						<div class="aaflex">
							<div class="agrey">总</div>
							<shuzi class="shuziren" :num="nums.status0[2]" :warn="true" :color="true"></shuzi>
						</div>
					</div>
					<div>
						<div class="agrey atitle">已办理事项</div>
						<div class="aaflex" style="margin-top: 5px;align-items: flex-end;">
							<div class="agrey">日</div>
							<shuzi style="font-size: 140%;" class="shuziren" :num="nums.status1[0]+nums.status2[0]"
								:warn="false"></shuzi>
						</div>
						<div class="aaflex">
							<div class="agrey">周</div>
							<shuzi class="shuziren" :num="nums.status1[1]+nums.status2[1]" :warn="true"></shuzi>
						</div>
						<div class="aaflex">
							<div class="agrey">总</div>
							<shuzi class="shuziren" :num="nums.status1[2]+nums.status2[2]" :warn="true"></shuzi>
						</div>
					</div>
					<div>
						<div class="agrey atitle">全部申报数</div>
						<div class="aaflex" style="margin-top: 5px;align-items: flex-end;">
							<div class="agrey">日</div>
							<shuzi style="font-size: 140%;" class="shuziren"
								:num="nums.status0[0]+nums.status1[0]+nums.status2[0]" :warn="false"></shuzi>
						</div>
						<div class="aaflex">
							<div class="agrey">周</div>
							<shuzi class="shuziren" :num="nums.status0[1]+nums.status1[1]+nums.status2[1]" :warn="true">
							</shuzi>
						</div>
						<div class="aaflex">
							<div class="agrey">总</div>
							<shuzi class="shuziren" :num="nums.status0[2]+nums.status1[2]+nums.status2[2]" :warn="true">
							</shuzi>
						</div>
					</div>
					<div>
						<div class="agrey atitle">访问人数</div>
						<div class="aaflex" style="margin-top: 5px;align-items: flex-end;">
							<div class="agrey">日</div>
							<shuzi style="font-size: 140%;" class="shuziren" :num="'***'" :warn="false"></shuzi>
						</div>
						<div class="aaflex">
							<div class="agrey">周</div>
							<shuzi class="shuziren" :num="'***'" :warn="true"></shuzi>
						</div>
						<div class="aaflex">
							<div class="agrey">总</div>
							<shuzi class="shuziren" :num="'***'" :warn="true"></shuzi>
						</div>
					</div>
				</div>

			</div>
		</el-card>
		<div style="display: flex;justify-content: space-between;margin-top: 10px;">
			<el-card style="width: 32%;">
				<div>
					<div style="font-size: 105%;margin-bottom: 10px;">类别分析(过去30天)</div>
				</div>
				<div id="a1" style="width:350px;height:300px;margin-top: 10px;"></div>
			</el-card>
			<el-card style="width: 32%;">
				<div>
					<div style="font-size: 105%;margin-bottom: 10px;">区域分析(过去30天)</div>
				</div>
				<el-table height="300" :data="areaban" border style="width: 100%">
					<el-table-column prop="name" label="区域名">
					</el-table-column>
					<el-table-column prop="num" label="办件数">
					</el-table-column>
				</el-table>
			</el-card>
			<el-card style="width: 32%;">
				<div>
					<div style="font-size: 105%;margin-bottom: 10px;">趋势分析(过去1年)</div>
				</div>
				<div id="a2" style="width:350px;height:300px;margin-top: 10px;"></div>
			</el-card>
		</div>
	</div>
</template>

<script>
	import shuzi from "../components/shuzi.vue"
	export default {
		data() {
			return {
				nums: {},
				areaban: []
			}
		},

		computed: {
			info() {
				let info = window.localStorage.getItem("info");
				return JSON.parse(info);
			},
			org() {
				let org = window.localStorage.getItem("org");
				return JSON.parse(org);
			}
		},
		components: {
			shuzi
		},
		async mounted() {
			await this.myEcharts();
			await this.qushi();
		},
		methods: {
			async qushi() {
				// 基于准备好的dom，初始化echarts实例
				var myChart = this.$echarts.init(document.getElementById('a2'));
				let ans = await axios.get(this.$url + "tongji/weekban", {
					params:{
						qu_id: this.org.area
					}
					
				});
				
				let lists = ans.data.lists;
				let types = [];
				let nums = [];
				lists.map(p => {
					types.push(p.a+"周");
					nums.push(p.num);
				})
				// 指定图表的配置项和数据
				var option = {
					xAxis: {
						type: 'category',
						data: types
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: nums,
						type: 'line',
						smooth: true
					}]
				};

				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			},
			async getareaban() {
				let ans = await axios.get(this.$url + "tongji/areaban_tj?qu_id=" + this.org.area);
				//console.log(this.org.area);
				this.areaban = ans.data.lists;
				console.log(ans);
			},
			async myEcharts() {
				// 基于准备好的dom，初始化echarts实例
				var myChart = this.$echarts.init(document.getElementById('a1'));
				let ans = await axios.get(this.$url + "tongji/typeban", {
					params:{
						qu_id: this.org.area
					}
					
				});
				let lists = ans.data.lists;
				let types = [];
				let nums = [];
				lists.map(p => {
					types.push(p.type);
					nums.push(p.num);
				})
				// 指定图表的配置项和数据
				var option = {
					title: {
						text: ''
					},
					tooltip: {},
					xAxis: {
						type: "category",
						data: types,
						axisLabel: {
							interval: 0,
							rotate: 40
						}
					},
					yAxis: {},
					series: [{
						name: '办件量',
						type: 'bar',
						data: nums
					}]
				};

				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			},
			async getzonglan() {
				let params = {
					token: this.info.uid,
					role: JSON.stringify(this.info.role)
				};
				if (this.org.area !== "371100000000") {
					params.area = this.org.area;
				};
				console.log(params);
				let ans = await axios.get(this.$url + "admin/zonglan", {
					params: params
				});
				this.nums = ans.data.lists;
			}
		},
		async created() {
			await this.getzonglan();
			await this.getareaban();
		}
	}
</script>
<style scoped>
	.el-upload-dragger {
		width: 300px !important;
	}
</style>
<style>
	.abody {
		padding-left: 40px;
		padding-right: 40px;
	}

	.aflex {
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.aaflex {
		display: flex;
		font-size: 95%;
		margin-top: 5px;
	}

	.agrey {
		color: #9a9a9a
	}

	.shuziren {
		margin-left: 20px;
	}

	.atitle {
		text-align: center;
	}
</style>